var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.747 20.443H21M11.021 6.00099L16.473 10.188M12.78 3.79499C13.1577 3.34868 13.6946 3.06731 14.2765 3.01073C14.8584 2.95414 15.4394 3.1268 15.896 3.49199L17.629 4.83899C17.8751 4.98492 18.0895 5.17869 18.2595 5.40884C18.4295 5.639 18.5517 5.90088 18.6188 6.17903C18.6859 6.45718 18.6966 6.74596 18.6503 7.02831C18.6039 7.31066 18.5015 7.58087 18.349 7.82299C18.315 7.87699 8.812 19.764 8.812 19.764C8.65414 19.9599 8.45474 20.1183 8.22819 20.2278C8.00164 20.3373 7.7536 20.3951 7.502 20.397L3.864 20.443L3.044 16.973C2.929 16.484 3.044 15.972 3.36 15.577L12.78 3.79499Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1);
export default __webpack_public_path__ + "static/media/edit_1.4447f4df92593015d535331ef8521595.svg";
export { ForwardRef as ReactComponent };